import './moderncatering/style';
import FormStructure from './moderncatering/form_structure';

export default FormStructure;